import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
// material
import { Box, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

// ----------------------------------------------------------------------
IconColor.propTypes = {
  sx: PropTypes.object
};

function IconColor({ sx, ...other }) {
  return (
    <Box
      sx={{
        width: 20,
        height: 20,
        display: 'flex',
        borderRadius: '50%',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'currentColor',
        transition: (theme) =>
          theme.transitions.create('all', {
            duration: theme.transitions.duration.shortest
          }),
        ...sx
      }}
      {...other}
    >
      <Icon icon={checkmarkFill} />
    </Box>
  );
}

ColorTagSinglePicker.propTypes = {
  colors: PropTypes.array.isRequired
};

export default function ColorTagSinglePicker({ colors, valueDefault, ...other }) {
  return (
    <RadioGroup row {...other}  defaultValue={valueDefault?valueDefault.color:null}>
      {colors.map((tags, index) => {
        const isWhite = tags.color === '#FFFFFF' || tags.color === 'white';

        return (
          <FormControlLabel
            key={index}
            value={tags}
            label={tags.tag}
            control={
              <Radio
                key={tags.id}
                value={JSON.stringify(tags)}
                color="default"
                icon={
                  <IconColor
                    sx={{
                      ...(isWhite && {
                        border: (theme) => `solid 1px ${theme.palette.divider}`
                      })
                    }}
                  />
                }
                checkedIcon={
                  <IconColor
                    sx={{
                      transform: 'scale(1.4)',
                      '&:before': {
                        opacity: 0.48,
                        width: '100%',
                        content: "''",
                        height: '100%',
                        borderRadius: '50%',
                        position: 'absolute',
                        boxShadow: '4px 4px 8px 0 currentColor'
                      },
                      '& svg': { width: 12, height: 12, color: 'common.white' },
                      ...(isWhite && {
                        border: (theme) => `solid 1px ${theme.palette.divider}`,
                        boxShadow: (theme) => `4px 4px 8px 0 ${theme.palette.grey[500_24]}`,
                        '& svg': { width: 12, height: 12, color: 'common.black' }
                      })
                    }}
                  />
                }
                sx={{
                  color: tags.color,
                  '&:hover': { opacity: 0.72 }
                }}
              />}
          />
        );
      })}
    </RadioGroup>
  );
}
